module.exports = __webpack_public_path__ + "static/media/0.cbae58b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/special/0.png
// module id = 1107
// module chunks = 0